export default "__VITE_ASSET__DzXEBYlm__"